import React from "react";

type UserDataInterface = { initialized: boolean; loggedIn: boolean; user: {user: string, id: string} };
type MyContextInterface = {
  authInfo: UserDataInterface;
  initialize: () => Promise<boolean>;
  logOut: () => Promise<boolean>;
  logIn: () => Promise<boolean>;
};

// create the context
export const AuthContext = React.createContext<MyContextInterface | undefined>(
  undefined
);

// create the context provider, we are using use state to ensure that
// we get reactive values from the context...
type Props = {
  children: React.ReactNode;
};
export const AuthProvider: React.FC = (props: any) => {
  // the reactive values
  const [authInfo, setAuthInfo] = React.useState<UserDataInterface>();

  const logOut = () => {
    return new Promise((resolve) => {
      window.localStorage.removeItem("AUTH");
      setAuthInfo({ initialized: true, loggedIn: false, user: {user: "", id: ""} });
      setTimeout(() => {
        return resolve(true);
      }, 1000);
    });
  };

  const logIn = (user: string, password: string) => {
    return new Promise((resolve) => {
      let v = {
        initialized: true,
        loggedIn: true,
        user: { user: user, id: new Date().getTime() + "" },
      };
      setAuthInfo(v);
      window.localStorage.setItem("AUTH", JSON.stringify(v.user));
      setTimeout(() => {
        return resolve(true);
      }, 1000);
    });
  };

  const initialize = () => {
    let response = window.localStorage.getItem("AUTH") || null;
    if (response !== null) {
      setAuthInfo({
        initialized: true,
        loggedIn: true,
        user: JSON.parse(response),
      });
    } else {
      setAuthInfo({
        initialized: true,
        loggedIn: false,
        user: {user: "", id: ""},
      });
    }
  };

  let v = {
    authInfo,
    logOut: logOut,
    logIn: logIn,
    initialize,
  };

  return <AuthContext.Provider value={v} {...props} />;
};

export const useAuth = () => React.useContext(AuthContext);